export enum CustomerModules {
  ORDER = 'ORDER',
  BOOKING_TABLE = 'BOOKING_TABLE',
  QUEUE = 'QUEUE',
}



// WEBPACK FOOTER //
// ./src/app/pages/customers/enums/customer-modules.enum.ts